import { JSX } from 'react';
import { Avatar, Tag, Tooltip, Typography } from 'antd';
import { Direction } from '@/shared/types/call-history';
import { MissedCallIcon } from '@/public/icons/colorful/MissedCall';
import { IncboundCallIcon } from '@/public/icons/colorful/InboundCall';
import { OutboundCallIcon } from '@/public/icons/colorful/OutboundCall';
import { RejectedCallIcon } from '@/public/icons/colorful/RejectedCall';
import { getFullName } from '@/shared/helpers/full-name-parser';
import './HistoryIcon.scss';

const { Text } = Typography;

export interface HistoryIconProps {
  fullName: string | null;
  date: Date;
  direction: Direction;
  subject: string | null;
  phoneNumber: string;
  size?: number;
  isPrevious?: boolean;
  isExternal?: boolean;
}

export function HistoryIcon(props: HistoryIconProps) {
  const getPhoneNumber = (phoneNumber: string): string => {
    return phoneNumber.replace(/\+/g, '');
  };

  const showDate = (): string => {
    return `${props.date.toLocaleString().replace(/\(.+\)/g, '')}`;
  };

  const renderCallIcon = (direction: Direction): JSX.Element => {
    switch (direction) {
      case 'inbound': {
        return <IncboundCallIcon />;
      }
      case 'outbound': {
        return <OutboundCallIcon />;
      }
      case 'rejected': {
        return <RejectedCallIcon />;
      }
      case 'noanswer': {
        return <MissedCallIcon />;
      }
      default:
        return <></>;
    }
  };

  return (
    <div className="history-icon">
      <Avatar
        className="custom-avatar"
        size={props?.size ?? 40}
        alt="Avatar"
        icon={renderCallIcon(props?.direction)}
      />
      <div className="history-icon__info">
        <div className="history-icon__name">
          <div className="history-icon__name-details">
            <Text
              ellipsis={{ tooltip: getFullName(props.fullName, props.subject) }}
              className="full-name"
            >
              {getFullName(props.fullName, props.subject)}
            </Text>
            {props?.isExternal && (
              <Tooltip
                className="history-icon__name-tooltip"
                title="This record was created outside of the Solgari application."
              >
                <Tag className="history-icon__name-tag" color="geekblue">
                  External
                </Tag>
              </Tooltip>
            )}
          </div>

          <div className="history-icon__phone-details">
            <Text className="phone">{getPhoneNumber(props.phoneNumber)}</Text>
            {props?.isPrevious && (
              <Tag className="history-icon__name-tag last-selected">Last</Tag>
            )}
          </div>
        </div>
        <div className="back-text">{showDate()}</div>
      </div>
    </div>
  );
}
